exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-53742f46]{font-size:1.7rem;text-align:left;margin-bottom:12px}#comparison_table[data-v-53742f46]{border-collapse:collapse}#comparison_table[data-v-53742f46],td[data-v-53742f46],th[data-v-53742f46]{border:1px solid #ced4da;text-align:left;font-size:.8rem}#comparison_table td[data-v-53742f46],#comparison_table th[data-v-53742f46]{padding:.5rem}#comparison_table th[data-v-53742f46]{background-color:#e8e8e8;font-weight:400}.provider-photo[data-v-53742f46]{max-width:80%;text-align:center;display:block;margin-left:auto;margin-right:auto;margin-bottom:.8rem}.close-icon[data-v-53742f46]{cursor:pointer;float:left;color:#4b5456}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53742f46","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Compare.vue
// module id = 105
// module chunks = 0